import React from "react";
import { formatMoney } from "../../utils/helpers/stringHelper";

export function AccountDetails({ label, account, arrears }) {
  let loanAmountAdvancedWording = account.accountType === "LOC" 
      ? label.creditLimit 
      :  label.total;
  return (
    <div className="display-flex account-details">
      <p>
        {loanAmountAdvancedWording}
        <br />
        <strong>
          <span>
            {formatMoney(account.loanAmountAdvanced, {
              removeZeroCents: false,
            })}
          </span>
        </strong>
      </p>
      <p>
        {label.repay}
        <br />
        <span className={`${arrears ? "bold-red" : "bold-green"}`}>
          {formatMoney(account.netBalance, { removeZeroCents: false })}
        </span>
      </p>
    </div>
  );
}
